// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js!../../../../../@phosphor/widgets/style/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../css-loader/dist/cjs.js!../../../../../font-awesome/css/font-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../../css-loader/dist/cjs.js!./os.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../../css-loader/dist/cjs.js!./dockpanel.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../../css-loader/dist/cjs.js!./dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../../css-loader/dist/cjs.js!./menus.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../../css-loader/dist/cjs.js!./sidepanel.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../../css-loader/dist/cjs.js!./tabs.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../../css-loader/dist/cjs.js!./scrollbars.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../../css-loader/dist/cjs.js!./tree.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../../css-loader/dist/cjs.js!./status-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../../../css-loader/dist/cjs.js!./tree-decorators.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../../../../css-loader/dist/cjs.js!./about.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../../../../css-loader/dist/cjs.js!./search-box.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../../../../css-loader/dist/cjs.js!./ansi.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../../../../css-loader/dist/cjs.js!./view-container.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../../../../css-loader/dist/cjs.js!./notification.css";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../../../../../css-loader/dist/cjs.js!./alert-messages.css";
import ___CSS_LOADER_AT_RULE_IMPORT_18___ from "-!../../../../../css-loader/dist/cjs.js!./icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_19___ from "-!../../../../../css-loader/dist/cjs.js!./widget.css";
import ___CSS_LOADER_AT_RULE_IMPORT_20___ from "-!../../../../../css-loader/dist/cjs.js!./quick-title-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_21___ from "-!../../../../../css-loader/dist/cjs.js!./progress-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_22___ from "-!../../../../../css-loader/dist/cjs.js!./breadcrumbs.css";
import ___CSS_LOADER_AT_RULE_IMPORT_23___ from "-!../../../../../css-loader/dist/cjs.js!./tooltip.css";
import ___CSS_LOADER_AT_RULE_IMPORT_24___ from "-!../../../../../css-loader/dist/cjs.js!./split-widget.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_18___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_19___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_20___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_21___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_22___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_23___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/*-----------------------------------------------------------------------------
| General
|----------------------------------------------------------------------------*/

:root {
    /* Borders: Width and color (dark to bright) */

    --theia-border-width: 1px;
    --theia-panel-border-width: 1px;

    /* UI fonts: Family, size and color (bright to dark)
     ---------------------------------------------------
     The UI font CSS variables are used for the typography all of the Theia
     user interface elements that are not directly user-generated content.
   */

    --theia-ui-font-scale-factor: 1.2;
  --theia-ui-font-size0: calc(
    var(--theia-ui-font-size1) / var(--theia-ui-font-scale-factor)
  );
  --theia-ui-font-size1: 13px; /* Base font size */
  --theia-ui-font-size2: calc(
    var(--theia-ui-font-size1) * var(--theia-ui-font-scale-factor)
  );
  --theia-ui-font-size3: calc(
    var(--theia-ui-font-size2) * var(--theia-ui-font-scale-factor)
  );
  --theia-ui-icon-font-size: 14px; /* Ensures px perfect FontAwesome icons */
    --theia-ui-font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

    /* Content fonts: Family, size and color (bright to dark)
     Content font variables are used for typography of user-generated content.
   */

    --theia-content-font-size: 13px;
    --theia-content-line-height: 22px;

    --theia-code-font-size: 13px;
    --theia-code-line-height: 17px;
    --theia-code-padding: 5px;
    --theia-code-font-family: Menlo, Monaco, Consolas, "Droid Sans Mono",
        "Courier New", monospace, "Droid Sans Fallback";
    --theia-monospace-font-family: monospace;
    --theia-ui-padding: 6px;

    /* Icons */
    --theia-icon-size: 16px;

    /* Scrollbars */
    --theia-scrollbar-width: 10px;
    --theia-scrollbar-rail-width: 10px;

    /* Statusbar */
    --theia-statusBar-font-size: 12px;

    /* Opacity for disabled mod  */
    --theia-mod-disabled-opacity: 0.4;
}

html,
body {
    height: 100vh;
}

body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: var(--theia-ui-font-family);
    background: var(--theia-editor-background);
    color: var(--theia-foreground);
    border: 1px solid var(--theia-window-activeBorder);
}
body:window-inactive,
body:-moz-window-inactive {
    border-color: var(--theia-window-inactiveBorder);
}

a {
    color: var(--theia-textLink-foreground);
}

a:active,
a:hover {
    color: var(--theia-textLink-activeForeground);
}

code {
    color: var(--theia-textPreformat-foreground);
}

blockquote {
    margin: 0 7px 0 5px;
    padding: 0px 16px 0px 10px;
    background: var(--theia-textBlockQuote-background);
    border-left: 5px solid var(--theia-textBlockQuote-border);
}

.theia-input {
    background: var(--theia-input-background);
    color: var(--theia-input-foreground);
    border: var(--theia-border-width) solid var(--theia-input-border);
    font-family: var(--theia-ui-font-family);
    font-size: var(--theia-ui-font-size1);
    line-height: var(--theia-content-line-height);
    padding-left: 5px;
    border-radius: 2px;
}

.theia-input[type="text"] {
    text-overflow: ellipsis;
    white-space: nowrap;
}

.theia-input::placeholder {
    color: var(--theia-input-placeholderForeground);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.theia-maximized {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: auto !important;
    height: auto !important;
    z-index: 255 !important;
    background: var(--theia-editor-background);
}

.theia-visible-menu-maximized {
    top: var(--theia-private-menubar-height) !important;
}

.theia-ApplicationShell {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--theia-editor-background);
}

.theia-preload {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50000;
    background: var(--theia-editor-background);
    background-size: 60px 60px;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    transition: opacity 0.8s;
    display: flex;
    justify-content: center;
    align-items: center;
}

.theia-preload::after {
    animation: 1s theia-preload-rotate infinite;
  color: #777; /* color works on both light and dark themes */
  content: "\\eb19"; /* codicon-load */
    font: normal normal normal 72px/1 codicon;
}

@keyframes theia-preload-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.theia-preload.theia-hidden {
    opacity: 0;
}

.theia-icon {
    width: 32px;
    height: 18px;
    margin: 5px;
    margin-left: 8px;
}

.theia-mod-disabled,
.theia-mod-disabled:focus {
    opacity: var(--theia-mod-disabled-opacity) !important;
}

.theia-header {
    text-transform: uppercase;
    font-size: var(--theia-ui-font-size0);
    font-weight: 700;
}

.p-Widget {
    font-size: var(--theia-ui-font-size1);
}

.p-Widget.p-mod-hidden {
    display: none !important;
}

.noselect,
.no-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    -o-user-select: none;
}

/* Since an iframe has its own focus tracking, we don't show focus on iframes */
:focus:not(iframe) {
    outline-width: 1px;
    outline-style: solid;
    outline-offset: -1px;
    opacity: 1;
    outline-color: var(--theia-focusBorder);
}

::selection {
    background: var(--theia-selection-background);
}

.action-label {
    padding: 2px;
    border-radius: 5px;
    cursor: pointer;
}

.action-label:hover {
    background-color: var(--theia-toolbar-hoverBackground);
}

.theia-button {
    border: none;
    color: var(--theia-button-foreground);
    min-width: 65px;
    outline: none;
    cursor: pointer;
    padding: 4px 9px;
    margin-left: calc(var(--theia-ui-padding) * 2);
    border-radius: 2px;
}

.theia-button:focus {
    outline: 1px solid var(--theia-focusBorder);
    outline-offset: 1px;
}

.theia-button.secondary {
    color: var(--theia-secondaryButton-foreground);
}

.theia-button[disabled] {
    opacity: 0.6;
    color: var(--theia-button-disabledForeground);
    background-color: var(--theia-button-disabledBackground);
    cursor: default;
}

button.secondary[disabled],
.theia-button.secondary[disabled] {
    color: var(--theia-secondaryButton-disabledForeground);
    background-color: var(--theia-secondaryButton-disabledBackground);
}

.theia-select {
    color: var(--dropdown-foreground);
    font-size: var(--theia-ui-font-size1);
    border-radius: 2px;
    border: 1px solid var(--theia-dropdown-border);
    background: var(--theia-dropdown-background);
    outline: none;
    cursor: pointer;
}

.theia-select option {
    background: var(--theia-dropdown-listBackground);
}

.theia-transparent-overlay {
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 999;
}

.theia-cursor-no-drop,
.theia-cursor-no-drop:active {
    cursor: no-drop;
}

/*-----------------------------------------------------------------------------
| Import children style files
|----------------------------------------------------------------------------*/
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAKjF;;8EAE8E;;AAE9E;IACI,8CAA8C;;IAE9C,yBAAyB;IACzB,+BAA+B;;IAE/B;;;;IAIA;;IAEA,iCAAiC;EACnC;;GAEC;EACD,2BAA2B,EAAE,mBAAmB;EAChD;;GAEC;EACD;;GAEC;EACD,+BAA+B,EAAE,yCAAyC;IACxE,sEAAsE;;IAEtE;;IAEA;;IAEA,+BAA+B;IAC/B,iCAAiC;;IAEjC,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;IACzB;uDACmD;IACnD,wCAAwC;IACxC,uBAAuB;;IAEvB,UAAU;IACV,uBAAuB;;IAEvB,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;;IAElC,cAAc;IACd,iCAAiC;;IAEjC,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,0CAA0C;IAC1C,8BAA8B;IAC9B,kDAAkD;AACtD;AACA;;IAEI,gDAAgD;AACpD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kDAAkD;IAClD,yDAAyD;AAC7D;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;IACpC,iEAAiE;IACjE,wCAAwC;IACxC,qCAAqC;IACrC,6CAA6C;IAC7C,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;IACd,0CAA0C;IAC1C,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;EAC7C,WAAW,EAAE,8CAA8C;EAC3D,gBAAgB,EAAE,iBAAiB;IACjC,yCAAyC;AAC7C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;EAEE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW;EACtC,wBAAwB,EAAE,mBAAmB;EAC7C,sBAAsB,EAAE,YAAY;EACpC,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB,EAAE;iEAC4C;IAC7D,oBAAoB;AACxB;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,wDAAwD;IACxD,eAAe;AACnB;;AAEA;;IAEI,sDAAsD;IACtD,iEAAiE;AACrE;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,8CAA8C;IAC9C,4CAA4C;IAC5C,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;8EAE8E","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n@import url(\"~@phosphor/widgets/style/index.css\");\n@import url(\"~font-awesome/css/font-awesome.min.css\");\n\n/*-----------------------------------------------------------------------------\n| General\n|----------------------------------------------------------------------------*/\n\n:root {\n    /* Borders: Width and color (dark to bright) */\n\n    --theia-border-width: 1px;\n    --theia-panel-border-width: 1px;\n\n    /* UI fonts: Family, size and color (bright to dark)\n     ---------------------------------------------------\n     The UI font CSS variables are used for the typography all of the Theia\n     user interface elements that are not directly user-generated content.\n   */\n\n    --theia-ui-font-scale-factor: 1.2;\n  --theia-ui-font-size0: calc(\n    var(--theia-ui-font-size1) / var(--theia-ui-font-scale-factor)\n  );\n  --theia-ui-font-size1: 13px; /* Base font size */\n  --theia-ui-font-size2: calc(\n    var(--theia-ui-font-size1) * var(--theia-ui-font-scale-factor)\n  );\n  --theia-ui-font-size3: calc(\n    var(--theia-ui-font-size2) * var(--theia-ui-font-scale-factor)\n  );\n  --theia-ui-icon-font-size: 14px; /* Ensures px perfect FontAwesome icons */\n    --theia-ui-font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n    /* Content fonts: Family, size and color (bright to dark)\n     Content font variables are used for typography of user-generated content.\n   */\n\n    --theia-content-font-size: 13px;\n    --theia-content-line-height: 22px;\n\n    --theia-code-font-size: 13px;\n    --theia-code-line-height: 17px;\n    --theia-code-padding: 5px;\n    --theia-code-font-family: Menlo, Monaco, Consolas, \"Droid Sans Mono\",\n        \"Courier New\", monospace, \"Droid Sans Fallback\";\n    --theia-monospace-font-family: monospace;\n    --theia-ui-padding: 6px;\n\n    /* Icons */\n    --theia-icon-size: 16px;\n\n    /* Scrollbars */\n    --theia-scrollbar-width: 10px;\n    --theia-scrollbar-rail-width: 10px;\n\n    /* Statusbar */\n    --theia-statusBar-font-size: 12px;\n\n    /* Opacity for disabled mod  */\n    --theia-mod-disabled-opacity: 0.4;\n}\n\nhtml,\nbody {\n    height: 100vh;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    font-family: var(--theia-ui-font-family);\n    background: var(--theia-editor-background);\n    color: var(--theia-foreground);\n    border: 1px solid var(--theia-window-activeBorder);\n}\nbody:window-inactive,\nbody:-moz-window-inactive {\n    border-color: var(--theia-window-inactiveBorder);\n}\n\na {\n    color: var(--theia-textLink-foreground);\n}\n\na:active,\na:hover {\n    color: var(--theia-textLink-activeForeground);\n}\n\ncode {\n    color: var(--theia-textPreformat-foreground);\n}\n\nblockquote {\n    margin: 0 7px 0 5px;\n    padding: 0px 16px 0px 10px;\n    background: var(--theia-textBlockQuote-background);\n    border-left: 5px solid var(--theia-textBlockQuote-border);\n}\n\n.theia-input {\n    background: var(--theia-input-background);\n    color: var(--theia-input-foreground);\n    border: var(--theia-border-width) solid var(--theia-input-border);\n    font-family: var(--theia-ui-font-family);\n    font-size: var(--theia-ui-font-size1);\n    line-height: var(--theia-content-line-height);\n    padding-left: 5px;\n    border-radius: 2px;\n}\n\n.theia-input[type=\"text\"] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.theia-input::placeholder {\n    color: var(--theia-input-placeholderForeground);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.theia-maximized {\n    position: fixed !important;\n    top: 0 !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: auto !important;\n    height: auto !important;\n    z-index: 255 !important;\n    background: var(--theia-editor-background);\n}\n\n.theia-visible-menu-maximized {\n    top: var(--theia-private-menubar-height) !important;\n}\n\n.theia-ApplicationShell {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: var(--theia-editor-background);\n}\n\n.theia-preload {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 50000;\n    background: var(--theia-editor-background);\n    background-size: 60px 60px;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-position: center;\n    transition: opacity 0.8s;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.theia-preload::after {\n    animation: 1s theia-preload-rotate infinite;\n  color: #777; /* color works on both light and dark themes */\n  content: \"\\eb19\"; /* codicon-load */\n    font: normal normal normal 72px/1 codicon;\n}\n\n@keyframes theia-preload-rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.theia-preload.theia-hidden {\n    opacity: 0;\n}\n\n.theia-icon {\n    width: 32px;\n    height: 18px;\n    margin: 5px;\n    margin-left: 8px;\n}\n\n.theia-mod-disabled,\n.theia-mod-disabled:focus {\n    opacity: var(--theia-mod-disabled-opacity) !important;\n}\n\n.theia-header {\n    text-transform: uppercase;\n    font-size: var(--theia-ui-font-size0);\n    font-weight: 700;\n}\n\n.p-Widget {\n    font-size: var(--theia-ui-font-size1);\n}\n\n.p-Widget.p-mod-hidden {\n    display: none !important;\n}\n\n.noselect,\n.no-select {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome and Opera */\n    -o-user-select: none;\n}\n\n/* Since an iframe has its own focus tracking, we don't show focus on iframes */\n:focus:not(iframe) {\n    outline-width: 1px;\n    outline-style: solid;\n    outline-offset: -1px;\n    opacity: 1;\n    outline-color: var(--theia-focusBorder);\n}\n\n::selection {\n    background: var(--theia-selection-background);\n}\n\n.action-label {\n    padding: 2px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.action-label:hover {\n    background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-button {\n    border: none;\n    color: var(--theia-button-foreground);\n    min-width: 65px;\n    outline: none;\n    cursor: pointer;\n    padding: 4px 9px;\n    margin-left: calc(var(--theia-ui-padding) * 2);\n    border-radius: 2px;\n}\n\n.theia-button:focus {\n    outline: 1px solid var(--theia-focusBorder);\n    outline-offset: 1px;\n}\n\n.theia-button.secondary {\n    color: var(--theia-secondaryButton-foreground);\n}\n\n.theia-button[disabled] {\n    opacity: 0.6;\n    color: var(--theia-button-disabledForeground);\n    background-color: var(--theia-button-disabledBackground);\n    cursor: default;\n}\n\nbutton.secondary[disabled],\n.theia-button.secondary[disabled] {\n    color: var(--theia-secondaryButton-disabledForeground);\n    background-color: var(--theia-secondaryButton-disabledBackground);\n}\n\n.theia-select {\n    color: var(--dropdown-foreground);\n    font-size: var(--theia-ui-font-size1);\n    border-radius: 2px;\n    border: 1px solid var(--theia-dropdown-border);\n    background: var(--theia-dropdown-background);\n    outline: none;\n    cursor: pointer;\n}\n\n.theia-select option {\n    background: var(--theia-dropdown-listBackground);\n}\n\n.theia-transparent-overlay {\n    background-color: transparent;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 999;\n}\n\n.theia-cursor-no-drop,\n.theia-cursor-no-drop:active {\n    cursor: no-drop;\n}\n\n/*-----------------------------------------------------------------------------\n| Import children style files\n|----------------------------------------------------------------------------*/\n\n@import \"./os.css\";\n@import \"./dockpanel.css\";\n@import \"./dialog.css\";\n@import \"./menus.css\";\n@import \"./sidepanel.css\";\n@import \"./tabs.css\";\n@import \"./scrollbars.css\";\n@import \"./tree.css\";\n@import \"./status-bar.css\";\n@import \"./tree-decorators.css\";\n@import \"./about.css\";\n@import \"./search-box.css\";\n@import \"./ansi.css\";\n@import \"./view-container.css\";\n@import \"./notification.css\";\n@import \"./alert-messages.css\";\n@import \"./icons.css\";\n@import \"./widget.css\";\n@import \"./quick-title-bar.css\";\n@import \"./progress-bar.css\";\n@import \"./breadcrumbs.css\";\n@import \"./tooltip.css\";\n@import \"./split-widget.css\";\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
